import { queryOptions, useMutation } from "@tanstack/react-query";

import { getLanguages, patch, UserPatchRequest } from "@/generated/api/users";

const useUpdateUserSettingsMutation = () =>
  useMutation({
    mutationFn: (params: UserPatchRequest) => patch(params),
    mutationKey: ["user", "update"],
  });

const appLanguagesQuery = () =>
  queryOptions({
    queryFn: ({ signal }) => getLanguages({ signal }),
    queryKey: ["app-languages"],
  });

export { appLanguagesQuery, useUpdateUserSettingsMutation };
